import React from 'react';
import { useDroneProvider } from '@src/core/features';
import { ArcDroneMarker } from '@src/core/controllers';
import { useFlightProvider } from '@src/features/order/provider';
import { isDroneSignalLost } from '@src/features/drone/utils';
import { FlightDroneProps } from './types';

const FlightDrone: React.FC<FlightDroneProps> = (props) => {
  const { drone, rotation } = props;
  const { drones } = useDroneProvider();
  const { gpsInfo, flightData } = useFlightProvider();

  const droneLat = Number(drone?.latitude);
  const droneLng = Number(drone?.longitude);

  const liveDrone = React.useMemo(
    () =>
      drone?.serialNumber
        ? drones.find((item) => item.serialNumber === drone.serialNumber)
        : undefined,
    [drones, drone?.serialNumber],
  );

  const lost = isDroneSignalLost(liveDrone ?? drone, gpsInfo, flightData?.serialNumber);

  return (
    <ArcDroneMarker.missionArrow
      position={{
        lat: droneLat,
        lng: droneLng,
      }}
      rotation={rotation}
      lost={lost}
    />
  );
};

export default FlightDrone;
